export const columnSpanToUseMapper = {
    0: {
        "regularScreen": 1,
        "largeScreen": 1
    },
    1: {
        "regularScreen": 1,
        "largeScreen": 2
    },
    2: {
        "regularScreen": 2,
        "largeScreen": 4
    },
    3: {
        "regularScreen": 3,
        "largeScreen": 4
    },
    4: {
        "regularScreen": 4,
        "largeScreen": 6
    },
    5: {
        "regularScreen": 3,
        "largeScreen": 5
    },
    6: {
        "regularScreen": 4,
        "largeScreen": 6
    },
}

export const columnSpanToSave = {

    "regularScreen": {
        1: 0,
        2: 2,
        3: 3,
        4: 4,
        5: 4,
        6: 4
    },
    "largeScreen": {
        1: 0,
        2: 1,
        3: 2,
        4: 2,
        5: 5,
        6: 4
    }

}

export const closePortalDefaultTabs = [
    {
        "id": "HOME",
        "name": "Home",
        "tab_type": "BOARD"
    },
    {
        "id": "AppsLibrary",
        "name": "Apps Library",
        "tab_type": "APPS"
    },
    {
        "id": "EXECUTIVE",
        "name": "Executive",
        "tab_type": "LIST"
    },
    {
        "id": "REPORTING",
        "name": "Reporting",
        "tab_type": "LIST"
    },
    {
        "id": "AI/ML",
        "name": "AI/ML",
        "tab_type": "LIST"
    },
    {
        "id": "JOURNAL ENTRY",
        "name": "Journal Entry",
        "tab_type": "LIST"
    },
    {
        "id": "ACCOUNT RECONCILIATION",
        "name": "Account Reconciliation",
        "tab_type": "LIST"
    },
    {
        "id": "TRACKERS / DELIVERABLES",
        "name": "Trackers/Deliverables",
        "tab_type": "LIST"
    },
]

export const tabTypes = {
    BOARD : "BOARD",
    LIST : "LIST"
}